<template>
  <div ref="host" class="ad-host">
    <div class="ad-stage" dir="rtl" :class="{ 'ad-stage--focus': !!focusedPanel, 'ad-stage_full': !!focusedPanel }"
      :style="{ transform: stageTransform }">
      <header class="ad-header">
        <div class="ad-row ad-row--20">
          <img :src="logo" contain width="34px" height="34px" class="logo ad-logo-btn" title="باز کردن منو"
            @click="openMenu" />
          <div class="ad-title">آسایار</div>
          <div class="ad-subtitle">( داشبورد واحد اعزام و راهبری )</div>
          <div class="ad-date">{{ today }}</div>
        </div>
        <div class="ad-row ad-row--36">
          <div class="ad-level-pill" :style="{ color: statusUi.color, background: statusUi.softBackground }">
            <span class="ad-dot ad-dot--12" :style="{ background: statusUi.color }"></span>
            وضعیت ناوگان: {{ statusUi.name }}
          </div>
          <!-- <div class="ad-conn" :style="{ color: connColor }">
            <span class="ad-dot ad-dot--12" :style="{ background: connColor }"></span>
            <span>{{ connLabel }}</span>
          </div> -->
          <span dir="ltr" class="ad-clock">{{ clock }}</span>
        </div>
      </header>

      <section class="ad-section" v-show="!focusedPanel">
        <div class="ad-section-head">
          <span class="ad-dot ad-dot--12" :style="{ background: connColor }"></span>
          <span class="ad-section-title ad-section-title--live">لحظه‌ای</span>
          <!-- <span class="ad-section-sub">بروزرسانی با هر سیگنال</span> -->
          <span class="ad-section-line"></span>
          <span class="ad-section-meta">
            آخرین بروزرسانی <span dir="ltr" class="ad-section-meta-val">{{ lastLiveSignalAt }}</span>
          </span>
        </div>

        <div class="ad-live-grid">
          <div class="ad-card ad-card--ready"
            :style="{ background: statusUi.background, borderColor: statusUi.border }">
            <div class="ad-card-head">
              <span class="ad-card-title">
                <span class="ad-icon ad-icon--48" :style="{ background: statusUi.iconBackground }">
                  <svg viewBox="0 0 24 24" width="27" height="27" fill="none" :stroke="statusUi.iconForeground"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path :d="icons.shield" />
                  </svg>
                </span>
                <span class="ad-card-title-text">آمادگی ناوگان</span>
              </span>
              <span class="ad-fleet-wrap">
                <span class="ad-fleet">
                  <span v-for="(f, i) in fleet" :key="i">{{ f.label }} <b>{{ f.value }}</b></span>
                </span>
                <span class="ad-pill" :class="{ 'ad-blink': statusUi.blink }"
                  :style="{ background: statusUi.pillBackground, color: statusUi.pillForeground }">{{ statusUi.name
                  }}</span>
              </span>
            </div>
            <div class="ad-ready-grid">
              <div class="ad-ring" :style="{ background: ringBackground }">
                <div class="ad-ring-inner" :style="{ background: statusUi.background }">
                  <span class="ad-ring-cap">کد آماده</span>
                  <span class="ad-ring-num" :style="{ color: statusUi.numberColor }">{{ availableCodes }}</span>
                  <span class="ad-ring-cap ad-ring-cap--b">
                    از {{ totalCodesFmt }} · <b :style="{ color: statusUi.numberColor }">{{ availablePercentFmt }}</b>
                  </span>
                </div>
              </div>
              <div class="ad-types">
                <div v-for="(t, i) in vehicleTypeRows" :key="i" class="ad-type">
                  <div class="ad-type-row">
                    <span class="ad-type-name">{{ t.label }}</span>
                    <span class="ad-type-count"><b :style="{ color: t.foreground }">{{ t.ready }}</b> / {{ t.total
                    }}</span>
                  </div>
                  <div class="ad-track8">
                    <div class="ad-track8-fill" :style="{ background: t.color, width: t.width }"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ad-card ad-card--pend" :style="{ background: pendingBackground, borderColor: pendingBorder }">
            <div class="ad-card-head">
              <span class="ad-card-title">
                <span class="ad-icon ad-icon--48 ad-icon--blue">
                  <svg viewBox="0 0 24 24" width="27" height="27" fill="none" stroke="#7fb0ff" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path :d="icons.hourglass" />
                  </svg>
                </span>
                <span class="ad-card-title-text">در انتظار اعزام</span>
              </span>
              <span class="ad-big56" :style="{ color: pendingColor }">{{ pendingTotalFmt }}</span>
            </div>
            <div class="ad-maxwait">
              <span class="ad-maxwait-label">بیشترین زمان انتظار</span>
              <span dir="ltr" class="ad-maxwait-val" :style="{ color: maxWaitColor }">{{ maxWait }}</span>
            </div>
            <div class="ad-grid4">
              <div v-for="t in pendingTiles" :key="t.key" class="ad-pend-tile"
                :style="{ background: t.background, borderColor: t.border }">
                <span class="ad-pend-tile-label">
                  <span class="ad-sq14" :style="{ background: t.color }"></span>{{ t.label }}
                </span>
                <span class="ad-pend-tile-num" :style="{ color: t.foreground }">{{ t.count }}</span>
                <span dir="ltr" class="ad-pend-tile-sub">{{ t.detail }}</span>
              </div>
            </div>
          </div>

          <div class="ad-card ad-card--act">
            <div class="ad-card-head">
              <span class="ad-card-title">
                <span class="ad-icon ad-icon--48 ad-icon--blue">
                  <svg viewBox="0 0 24 24" width="27" height="27" fill="none" stroke="#7fb0ff" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path :d="icons.truck" />
                  </svg>
                </span>
                <span class="ad-card-title-text">فوریت‌های جاری</span>
              </span>
              <span class="ad-big56 ad-big56--white">{{ activeTotalFmt }}</span>
            </div>
            <div class="ad-act-bar-wrap">
              <div class="ad-act-bar">
                <div v-for="t in activeTiles" :key="t.key" class="ad-act-bar-seg"
                  :style="{ background: t.color, width: t.width }">
                </div>
              </div>
              <span class="ad-act-caption">توزیع فوریت‌های در حال انجام بر اساس سطح تریاژ</span>
            </div>
            <div class="ad-grid4">
              <div v-for="t in activeTiles" :key="t.key" class="ad-act-tile" :style="{ borderTopColor: t.color }">
                <span class="ad-act-tile-label">{{ t.label }}</span>
                <span class="ad-act-tile-num">{{ t.count }}</span>
                <span class="ad-act-tile-sub">{{ t.share }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ad-section" :class="{ 'ad-section--focus': !!focusedPanel }">
        <div class="ad-section-head" v-show="!focusedPanel">
          <span class="ad-sq12"></span>
          <span class="ad-section-title ad-section-title--shift">شیفت جاری</span>
          <span class="ad-section-sub">تجمیعی از {{ shiftStart }} تا اکنون · {{ dispatchedCount }} اعزام</span>
          <span class="ad-progress">
            <span class="ad-progress-fill" :style="{ width: progress }"></span>
          </span>
          <span class="ad-section-meta ad-section-meta--nowrap">
            بروزرسانی <span dir="ltr" class="ad-section-meta-val">{{ lastAggregateAt }}</span>
            · بعدی <span class="ad-section-meta-val">{{ countdown }}</span> ثانیه
          </span>
        </div>

        <div class="ad-bottom-grid" :class="{ 'ad-bottom-grid--focus': !!focusedPanel }">
          <div class="ad-panel ad-panel--sla"
            :class="{ 'is-fullscreen': focusedPanel === 'sla', 'is-hidden': focusedPanel && focusedPanel !== 'sla' }">
            <div class="ad-panel-head ad-panel-head--sla">
              <span class="ad-card-title">
                <span class="ad-icon ad-icon--42">
                  <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path :d="icons.gauge" />
                  </svg>
                </span>
                <span class="ad-panel-title">سطح سرویس</span>
              </span>
              <button type="button" class="ad-focus-btn"
                :title="focusedPanel === 'sla' ? 'خروج از تمام‌صفحه (Esc)' : 'تمام‌صفحه'" @click="toggleFocus('sla')">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path :d="focusedPanel === 'sla' ? icons.compress : icons.expand" />
                </svg>
              </button>
            </div>
            <div class="ad-sla-grid">
              <div v-for="(g, gi) in slaPriorityGroups" :key="gi" class="ad-sla-group">
                <div class="ad-sla-group-title" :style="{ color: g.color }">
                  <span class="ad-sq10" :style="{ background: g.color }"></span>{{ g.title }}
                </div>
                <div v-for="(r, ri) in g.rows" :key="ri" class="ad-sla-row">
                  <div class="ad-sla-row-top">
                    <span class="ad-sla-row-label">
                      <span class="ad-ellipsis">{{ r.label }}</span>
                      <span v-if="r.isCity" title="شهری" class="ad-icon ad-icon--28">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#c9d6f2" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round">
                          <path :d="icons.building" />
                        </svg>
                      </span>
                      <span v-if="r.isRural" title="برون‌شهری" class="ad-icon ad-icon--28">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#c9d6f2" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round">
                          <path :d="icons.tree" />
                        </svg>
                      </span>
                    </span>
                    <span class="ad-sla-row-val" :style="{ color: r.color }">{{ r.value }}</span>
                  </div>
                  <div class="ad-sla-track">
                    <div class="ad-sla-fill" :style="{ width: r.width, background: r.color }"></div>
                    <div class="ad-sla-marker" :style="{ right: r.markerPosition }"></div>
                  </div>
                  <div class="ad-sla-row-bottom">
                    <span>هدف {{ r.goal }}</span>
                    <span :style="{ color: r.color }">{{ r.statusName }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ad-cap-title">
              <span class="ad-sq10"></span>ظرفیت عملیاتی<span class="ad-cap-title-sub">· لحظه‌ای</span>
            </div>
            <div class="ad-grid4 ad-grid4--cap">
              <div v-for="(r, i) in slaCapacityRows" :key="i" class="ad-cap-tile"
                :style="{ background: r.softBackground, borderColor: r.color }">
                <span class="ad-cap-val" :style="{ color: r.color }">{{ r.value }}</span>
                <span class="ad-cap-label">{{ r.label }}</span>
                <span v-if="r.hasGoal" class="ad-cap-goal">هدف {{ r.goal }}</span>
              </div>
            </div>
          </div>

          <div class="ad-panel ad-panel--zones"
            :class="{ 'is-fullscreen': focusedPanel === 'zones', 'is-hidden': focusedPanel && focusedPanel !== 'zones' }">
            <div class="ad-panel-head">
              <span class="ad-card-title">
                <span class="ad-icon ad-icon--42">
                  <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path :d="icons.map" />
                  </svg>
                </span>
                <span class="ad-panel-title">وضعیت مناطق</span>
                <span class="ad-zone-count">{{ zoneCountLabel }}</span>
              </span>
              <span v-if="zoneLayout.many" class="ad-zsum">
                <span v-for="(s, i) in zoneLevelSummary" :key="i" class="ad-zsum-pill"
                  :style="{ background: s.softBackground, color: s.color }">
                  <span class="ad-dot ad-dot--10" :style="{ background: s.color }"></span>{{ s.value }}
                </span>
              </span>
              <span class="ad-rec mr-auto"
                :style="{ background: recommendation.background, borderColor: recommendation.border, color: recommendation.color }">
                <span class="ad-dot ad-dot--10" :style="{ background: recommendation.color }"></span>{{
                  recommendation.title }}
              </span>
              <button type="button" class="ad-focus-btn"
                :title="focusedPanel === 'zones' ? 'خروج از تمام‌صفحه (Esc)' : 'تمام‌صفحه'"
                @click="toggleFocus('zones')">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path :d="focusedPanel === 'zones' ? icons.compress : icons.expand" />
                </svg>
              </button>
            </div>

            <!-- نمای کارت (۱۰ منطقه یا کمتر) -->
            <div v-if="!zoneLayout.chart && !zoneLayout.many" class="ad-zcards">
              <div v-for="(z, i) in viewZones" :key="i" class="ad-zcard" :style="{
                flex: '1 1 ' + zoneLayout.basis,
                background: z.tileBackground,
                borderColor: z.tileBorder,
                padding: zoneLayout.tilePad
              }">
                <div class="ad-zcard-top">
                  <span class="ad-zcard-name-wrap">
                    <span class="ad-zcard-dot"
                      :style="{ background: z.color, boxShadow: '0 0 0 4px ' + z.softBackground }"></span>
                    <span class="ad-zcard-name" :style="{ fontSize: zoneLayout.nameFont }">{{ z.name }}</span>
                  </span>
                  <span class="ad-zcard-resp-wrap">
                    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="#93a6cf" stroke-width="2.2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path :d="icons.clock" />
                    </svg>
                    <span dir="ltr" :style="{ color: z.respColor }">{{ z.resp }}</span>
                  </span>
                </div>
                <div class="ad-zcard-ready">
                  <span class="ad-zcard-ready-num" :style="{ fontSize: zoneLayout.readyFont, color: z.color }">{{
                    z.ready }}</span>
                  <span class="ad-zcard-ready-cap">آماده از {{ z.total }} کد</span>
                </div>
                <div class="ad-zsegs" :style="{ height: zoneLayout.segH, fontSize: zoneLayout.segFont }">
                  <div class="ad-zseg ad-zseg--ready"
                    :style="{ flex: z.readyN + ' 0 ' + zoneLayout.segMin, background: z.color }">
                    <svg v-if="zoneLayout.icons" viewBox="0 0 24 24" width="12" height="12" fill="none"
                      stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
                      <path :d="icons.check" />
                    </svg>
                    <span>{{ z.ready }}</span>
                  </div>
                  <div class="ad-zseg ad-zseg--busy" :style="{ flex: z.busyN + ' 0 ' + zoneLayout.segMin }">
                    <svg v-if="zoneLayout.icons" viewBox="0 0 24 24" width="12" height="12" fill="none"
                      stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
                      <path :d="icons.truckSm" />
                    </svg>
                    <span>{{ z.busy }}</span>
                  </div>
                  <div class="ad-zseg ad-zseg--oos" :style="{ flex: z.outOfServiceN + ' 0 ' + zoneLayout.segMin }">
                    <svg v-if="zoneLayout.icons" viewBox="0 0 24 24" width="12" height="12" fill="none"
                      stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
                      <path :d="icons.wrench" />
                    </svg>
                    <span>{{ z.outOfService }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- نمای کارت فشرده (بیش از ۱۰ منطقه) -->
            <div v-if="!zoneLayout.chart && zoneLayout.many" class="ad-zcompact">
              <div v-for="(z, i) in viewZones" :key="i" class="ad-zmini"
                :style="{ background: z.tileBackground, borderColor: z.tileBorder }">
                <div class="ad-zmini-bars">
                  <div class="ad-zmini-bar"
                    :style="{ flex: z.readyN + ' 0 20px', background: z.color, color: '#06101f' }">{{
                      z.ready }}</div>
                  <div class="ad-zmini-bar"
                    :style="{ flex: z.busyN + ' 0 20px', background: '#4f8cff', color: '#06101f' }">{{ z.busy }}</div>
                  <div class="ad-zmini-bar"
                    :style="{ flex: z.outOfServiceN + ' 0 20px', background: '#5b6f99', color: '#eaf0fd' }">{{
                      z.outOfService }}</div>
                </div>
                <div class="ad-zmini-info">
                  <span class="ad-zmini-name">{{ z.name }}</span>
                  <span class="ad-zmini-ready-row">
                    <span class="ad-zmini-ready" :style="{ color: z.color }">{{ z.ready }}</span>
                    <span class="ad-zmini-pct" :style="{ color: z.color }">{{ z.pct }}</span>
                  </span>
                  <span class="ad-zmini-of">از {{ z.total }}</span>
                  <span dir="ltr" class="ad-zmini-resp" :style="{ color: z.respColor }">{{ z.resp }}</span>
                </div>
              </div>
            </div>

            <!-- نمای نمودار -->
            <template v-if="zoneLayout.chart">
              <div class="ad-zlegend">
                <span class="ad-zlegend-item"><span class="ad-sq12" style="background:#22c55e"></span>آماده (رنگ
                  وضعیت)</span>
                <span class="ad-zlegend-item"><span class="ad-sq12" style="background:#4f8cff"></span>در ماموریت</span>
                <span class="ad-zlegend-item"><span class="ad-sq12" style="background:#5b6f99"></span>خارج از
                  سرویس 7-10</span>
              </div>
              <div class="ad-zchart"
                :style="{ gridTemplateColumns: zoneLayout.chartCols, gridTemplateRows: zoneLayout.chartRows }">
                <div v-for="(z, i) in viewZones" :key="i" class="ad-zrow"
                  :style="{ gridTemplateColumns: zoneLayout.rowCols }">
                  <span class="ad-zrow-name" :style="{ fontSize: zoneLayout.nameFont }">
                    <span class="ad-dot ad-dot--10 ad-dot--noshrink" :style="{ background: z.color }"></span>
                    <span class="ad-zrow-text">{{ z.name }}</span>
                  </span>
                  <div class="ad-zrow-bar" :style="{ height: zoneLayout.barH }">
                    <div class="ad-zrow-seg ad-zrow-seg--ready"
                      :style="{ flex: z.readyN + ' 0 28px', background: z.color }">{{
                        z.ready }}</div>
                    <div class="ad-zrow-seg ad-zrow-seg--busy" :style="{ flex: z.busyN + ' 0 28px' }">{{ z.busy }}</div>
                    <div class="ad-zrow-seg ad-zrow-seg--oos" :style="{ flex: z.outOfServiceN + ' 0 28px' }">{{
                      z.outOfService }}</div>
                  </div>
                  <span dir="ltr" class="ad-zrow-resp" :style="{ color: z.respColor }">{{ z.resp }}</span>
                </div>
              </div>
            </template>
          </div>

          <div class="ad-panel ad-panel--times"
            :class="{ 'is-fullscreen': focusedPanel === 'times', 'is-hidden': focusedPanel && focusedPanel !== 'times' }">
            <div class="ad-panel-head">
              <span class="ad-card-title">
                <span class="ad-icon ad-icon--42">
                  <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="#8ea2c9" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path :d="icons.timer" />
                  </svg>
                </span>
                <span class="ad-panel-title">زمان‌های کلیدی</span>
              </span>
              <button type="button" class="ad-focus-btn"
                :title="focusedPanel === 'times' ? 'خروج از تمام‌صفحه (Esc)' : 'تمام‌صفحه'"
                @click="toggleFocus('times')">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path :d="focusedPanel === 'times' ? icons.compress : icons.expand" />
                </svg>
              </button>
            </div>
            <div class="ad-times">
              <div v-for="(t, i) in timeMetrics" :key="i" class="ad-time">
                <span class="ad-time-label">{{ t.label }}</span>
                <div class="ad-time-row">
                  <span dir="ltr" class="ad-time-val" :style="{ color: t.color }">{{ t.value }}</span>
                  <span class="ad-time-goal">هدف <span dir="ltr">{{ t.goal }}</span></span>
                </div>
                <div class="ad-time-track">
                  <div class="ad-time-fill" :style="{ background: t.color, width: t.width }"></div>
                  <div class="ad-time-marker" :style="{ right: t.markerPosition }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="ad-footer" v-show="focusedPanel" :style="{ borderColor: statusUi.color }">
        <span class="ad-dot ad-dot--12" :style="{ background: statusUi.color }"></span>
        <!-- <span v-if="statusUi.name != 'عادی'" class="titleStatus" :style="{ color: statusUi.color }">
          سایر بخش‌ها در وضعیت عادی
        </span>
        <template v-else> -->
        <span class="titleStatus" :style="{ color: statusUi.color }"> وضعیت ناوگان : {{ statusUi.name }}</span>
        -
        <span class="titleStatus" :style="{ color: pendingColor }"> {{ pendingTotalFmt }} ماموریت در انتظار
          اعزام</span>
        -
        <span class="titleStatus" :style="{ color: 'red' }">
          {{ pendingRedCountFormatted }} قرمز
        </span>
        -
        <span class="titleStatus" :style="{ color: statusUi.numberColor }"> {{ availableCodes }} کد آماده</span>
        <!-- </template> -->
      </div>
    </div>
  </div>
</template>

<script>

const pad2 = n => String(n).padStart(2, '0').split('').map(c => '۰۱۲۳۴۵۶۷۸۹'[c] || c).join('')
const faNum = n => Number(n).toLocaleString('fa-IR', { useGrouping: false })
const fmtDuration = s => {
  s = Math.max(0, Math.round(s))
  return pad2(Math.floor(s / 60)) + ':' + pad2(s % 60)
}
const clamp = (v, a, b) => Math.max(a, Math.min(b, v))
const fmtTime = t => t.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })

const VEHICLE_TYPES = [
  { label: 'آمبولانس', total: 92, factor: 0.95 },
  { label: 'موتورلانس', total: 16, factor: 1.2 },
  { label: 'سایر', total: 12, factor: 1.15 }
]

const TRIAGE_LEVELS = [
  { key: 'r', label: 'قرمز', color: '#ef4444' },
  { key: 'y', label: 'زرد', color: '#facc15' },
  { key: 'g', label: 'سبز', color: '#22c55e' },
  { key: 'w', label: 'سفید', color: '#e2e8f0' }
]
const STATUS_STYLES = {
  normal: { name: 'عادی', color: '#22c55e', background: '#0f1f45', border: '#24407a', pillBackground: '#14532d', pillForeground: '#bbf7d0', numberColor: '#4ade80', iconBackground: '#1a3166', iconForeground: '#7fb0ff' },
  warning: { name: 'هشدار', color: '#f59e0b', background: '#2a1f08', border: '#f59e0b', pillBackground: '#f59e0b', pillForeground: '#1a1205', numberColor: '#fbbf24', iconBackground: '#3d2a08', iconForeground: '#fbbf24' },
  critical: { name: 'بحرانی', color: '#f97316', background: '#2e1508', border: '#f97316', pillBackground: '#f97316', pillForeground: '#1a0c03', numberColor: '#fb923c', iconBackground: '#4a2108', iconForeground: '#fb923c' },
  emergency: { name: 'اضطرار', color: '#ef4444', background: '#3a0d16', border: '#ef4444', pillBackground: '#ef4444', pillForeground: '#fff', numberColor: '#ff6b6b', iconBackground: '#5c1420', iconForeground: '#ff6b6b', blink: true }
}

const STATE_COLORS = {
  g: { color: '#4ade80', name: 'سبز', softBackground: 'rgba(34,197,94,.16)' },
  y: { color: '#fbbf24', name: 'زرد', softBackground: 'rgba(245,158,11,.18)' },
  r: { color: '#ff6b6b', name: 'قرمز', softBackground: 'rgba(239,68,68,.2)' }
}
const SHIFTS = [
  { name: 'شیفت صبح', start: 7 },
  { name: 'شیفت عصر', start: 15 },
  { name: 'شیفت شب', start: 23 }
]

/* ════════════ موتور قوانین (rules) ════════════
   همه‌ی آستانه‌ها، رنگ‌ها و متن‌های شرطی از سرور (getDashboardMain800 → data.rules) می‌آیند.
   DEFAULT_RULES فقط fallback است تا اگر سرور چیزی نفرستاد صفحه خالی نشود. */

// سطح بر اساس درصد: levels به‌ترتیب با belowPercent؛ آخرین مورد (بدون belowPercent) = fallback
const levelByPercent = (percent, levels) => {
  const list = Array.isArray(levels) ? levels : []
  const bounded = list.filter(l => l.belowPercent != null).sort((a, b) => a.belowPercent - b.belowPercent)
  const hit = bounded.find(l => percent < l.belowPercent)
  if (hit) return hit.key
  const fallback = list.find(l => l.belowPercent == null)
  return fallback ? fallback.key : 'normal'
}
// وضعیت سه‌گانه g/y/r با { good, warn, direction }
const stateByThreshold = (value, rule) => {
  if (rule.direction === 'lowerIsBetter') return value <= rule.good ? 'g' : value <= rule.warn ? 'y' : 'r'
  return value >= rule.good ? 'g' : value >= rule.warn ? 'y' : 'r'
}
// 'r' / 'y' / null بر اساس { warnAboveSec, dangerAboveSec }
const severityByAbove = (value, rule) => (value > rule.dangerAboveSec ? 'r' : value > rule.warnAboveSec ? 'y' : null)
const fillTokens = (text, tokens) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (tokens[k] != null ? tokens[k] : m))

const DEFAULT_RULES = {
  styles: STATUS_STYLES,
  stateColors: STATE_COLORS,
  fleet: {
    emergencyWhenPendingExceedsAvailable: true,
    zeroReadyIsDanger: true,
    levels: [
      { key: 'emergency', belowPercent: 10 },
      { key: 'critical', belowPercent: 20 },
      { key: 'warning', belowPercent: 35 },
      { key: 'normal' }
    ]
  },
  pending: { alertRanks: ['r'], alertTileBackground: 'rgba(239,68,68,.18)' },
  maxWait: { warnAboveSec: 60, dangerAboveSec: 120 },
  zoneResponse: { warnAboveSec: 15 * 60, dangerAboveSec: 18 * 60 },
  recommendations: {
    normal: { title: 'وضعیت پایدار', message: 'ظرفیت ناوگان در همه مناطق کافی است.' },
    warning: { title: 'هشدار', message: 'آماده‌باش شیفت بعدی و انتقال ۲ کد از {best} به {worst}' },
    critical: { title: 'بحران', message: 'آزادسازی ماموریت‌های سبز برای {redPending} ماموریت قرمز · انتقال کد از {best} به {worst}' },
    emergency: { title: 'اضطرار', message: 'لغو ماموریت‌های سبز و سفید به نفع قرمز · طرح اضطراری و درخواست پشتیبانی از مراکز همجوار' }
  },
  sla: {
    groups: [
      {
        title: 'سطح قرمز', color: '#ff6b6b', display: 'bars',
        rows: [
          { label: 'ابلاغ زیر ۳۰ ثانیه', metric: 'dispatchP1', kind: 'percent', goalText: '٪۹۰', good: 90, warn: 80 },
          { label: 'رسیدن زیر ۱۵ دقیقه', metric: 'arrivalP1WithinCity15', kind: 'percent', area: 'city', goalText: '٪۹۰', good: 90, warn: 80 },
          { label: 'رسیدن زیر ۱۵ دقیقه', metric: 'arrivalP1OutsideCity15', kind: 'percent', area: 'rural', goalText: '٪۹۰', good: 90, warn: 80 }
        ]
      },
      {
        title: 'سطح زرد، سبز و سفید', color: '#fbbf24', display: 'bars',
        rows: [
          { label: 'ابلاغ زیر ۶۰ ثانیه', metric: 'dispatchP2', kind: 'percent', goalText: '٪۹۰', good: 90, warn: 80 },
          { label: 'رسیدن زیر ۴۰ دقیقه', metric: 'arrivalP2WithinCity40', kind: 'percent', area: 'city', goalText: '٪۹۰', good: 90, warn: 80 },
          { label: 'رسیدن زیر ۴۰ دقیقه', metric: 'arrivalP2OutsideCity40', kind: 'percent', area: 'rural', goalText: '٪۹۰', good: 90, warn: 80 }
        ]
      },
      {
        title: 'ظرفیت عملیاتی', color: '#7fb0ff', display: 'tiles',
        rows: [
          { label: 'بدون فاقدی', metric: 'coverage', kind: 'percent', goalText: '٪۹۰ و بالاتر', good: 90, warn: 80 },
          { label: 'تأخیر حرکت بالای ۲ دقیقه', metric: 'movingDelay', kind: 'count', direction: 'lowerIsBetter', good: 0, warn: 2 },
          { label: 'بالین بالای ۲۰ دقیقه', metric: 'sceneStayDelay', kind: 'count', direction: 'lowerIsBetter', good: 0, warn: 2 },
          { label: 'بیمارستان بالای ۳۰ دقیقه', metric: 'hospitalDelay', kind: 'count', direction: 'lowerIsBetter', good: 0, warn: 2 }
        ]
      }
    ]
  },
  times: [
    { label: 'میانگین زمان پاسخ · شهری', metric: 'responseCityAvg', goalSec: 15 * 60 },
    { label: 'میانگین زمان پاسخ · برون‌شهری', metric: 'responseRuralAvg', goalSec: 30 * 60 },
    { label: 'میانگین زمان اعزام تا حرکت', metric: 'dispatchToMoveAvg', goalSec: 60 },
    { label: 'میانگین زمان ماندگاری بر بالین', metric: 'patientWaitAvg', goalSec: 20 * 60 },
    { label: 'میانگین زمان ماندگاری در بیمارستان', metric: 'hospitalWaitAvg', goalSec: 30 * 60 }
  ]
}

const ICONS = {
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  hourglass: 'M5 22h14 M5 2h14 M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22 M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2',
  truck: 'M10 10H6 M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2 M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14 M8 8v4 M9 18h6 M17 16a2 2 0 1 0 0 4a2 2 0 1 0 0-4z M7 16a2 2 0 1 0 0 4a2 2 0 1 0 0-4z',
  truckSm: 'M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2 M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14 M9 18h6 M17 16a2 2 0 1 0 0 4a2 2 0 1 0 0-4z M7 16a2 2 0 1 0 0 4a2 2 0 1 0 0-4z',
  gauge: 'M12 14l4-4 M3.34 19a10 10 0 1 1 17.32 0',
  building: 'M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18z M6 12H4a2 2 0 0 0-2 2v8h4 M18 9h2a2 2 0 0 1 2 2v11h-4 M10 6h4 M10 10h4 M10 14h4 M10 18h4',
  tree: 'M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0z M7 16v6 M13 19v3 M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5',
  map: 'M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z M9 3v15 M15 6v15',
  clock: 'M12 6v6l4 2 M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z',
  check: 'M20 6L9 17l-5-5',
  wrench: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z',
  timer: 'M10 2h4 M12 14l3-3 M12 6a8 8 0 1 0 0 16a8 8 0 1 0 0-16z',
  expand: 'M15 3h6v6 M9 21H3v-6 M21 3l-7 7 M3 21l7-7',
  compress: 'M4 14h6v6 M20 10h-6V4 M14 10l7-7 M10 14l-7 7'
}

// در dispatchServiceLevelSetting: xxxTarget = درصد هدف (مثلاً ۹۰)، xxxValue = حد زمانی (ثانیه برای ابلاغ، دقیقه برای رسیدن)
// اگر برعکس است true را false کن
const SLA_TARGET_IS_PERCENT = true

const rulesFromSetting = setting => {
  const out = {}
  if (!setting || typeof setting !== 'object') return out
  const num = v => (v === null || v === undefined || v === '' || isNaN(Number(v)) ? null : Number(v))
  const pos = v => (num(v) !== null && num(v) > 0 ? num(v) : null)
  const orDef = (v, d) => (v === null ? d : v)

  const levelsFrom = o => {
    if (!o) return null
    const e = num(o.emergencyBelowPercentage)
    const c = num(o.criticalBelowPercentage)
    const w = num(o.warningBelowPercentage)
    if (e === null || c === null || w === null || e + c + w <= 0) return null
    return [
      { key: 'emergency', belowPercent: e },
      { key: 'critical', belowPercent: c },
      { key: 'warning', belowPercent: w },
      { key: 'normal' }
    ]
  }

  // آمادگی ناوگان
  const fleetLevels = levelsFrom(setting.vehicleReadinessSetting)
  if (fleetLevels) out.fleet = { levels: fleetLevels }

  // مناطق
  const zs = setting.dispatchZoneSetting
  const zoneLevels = levelsFrom(zs)
  if (zoneLevels) out.zoneLevels = zoneLevels
  if (zs && pos(zs.yellowResponseTimeHigherThan) !== null && pos(zs.redResponseTimeHigherThan) !== null) {
    out.zoneResponse = {
      warnAboveSec: pos(zs.yellowResponseTimeHigherThan),
      dangerAboveSec: pos(zs.redResponseTimeHigherThan)
    }
  }

  // بیشترین زمان انتظار (سفید تا X، زرد تا Y، بعد قرمز)
  const aw = setting.awaitingSetting
  if (aw && pos(aw.timerWhiteBelow) !== null && pos(aw.timerYellowBelow) !== null) {
    out.maxWait = {
      warnAboveSec: pos(aw.timerWhiteBelow),
      dangerAboveSec: pos(aw.timerYellowBelow)
    }
  }

  // سطح سرویس
  const ds = setting.dispatchServiceLevelSetting
  if (ds) {
    const redRatio = (pos(ds.redBelowPercentage) ?? 80) / 100
    const pick = (a, b) => (SLA_TARGET_IS_PERCENT ? [pos(a), pos(b)] : [pos(b), pos(a)])
    const pctRow = (unitText, metric, tgt, val, defLimit, area) => {
      const [percent, limit] = pick(tgt, val)
      const t = orDef(percent, 90)
      return {
        label: unitText.replace('{n}', faNum(orDef(limit, defLimit))),
        metric,
        kind: 'percent',
        area,
        goalText: '٪' + faNum(t),
        good: t,
        warn: Math.round(t * redRatio * 10) / 10,
        markerAt: t
      }
    }
    const cntRow = (label, metric, target, yellowTar, redTar, defTarget) => {
      const t = orDef(pos(target), defTarget)
      return {
        label: label.replace('{n}', faNum(t)),
        metric, kind: 'count', direction: 'lowerIsBetter',
        good: num(yellowTar - 1 > 0 ? yellowTar - 1 : 0) ?? 0,
        warn: redTar ?? 0
      }
    }
    const base = DEFAULT_RULES.sla.groups
    const covGood = orDef(pos(ds.yellowBelowPercentage), 90)
    out.sla = {
      groups: [
        {
          ...base[0],
          rows: [
            pctRow('ابلاغ زیر {n} ثانیه', 'dispatchP1', ds.redRankDispatchTarget, ds.redRankDispatchValue, 30),
            pctRow('رسیدن زیر {n} دقیقه', 'arrivalP1WithinCity15', ds.redRankArriveInCityTarget, ((ds.redRankArriveInCityValue ?? 1) / 60), 15, 'city'),
            pctRow('رسیدن زیر {n} دقیقه', 'arrivalP1OutsideCity15', ds.redRankArriveOutOfCityTarget, ((ds.redRankArriveOutOfCityValue ?? 1) / 60), 15, 'rural')
          ]
        },
        {
          ...base[1],
          rows: [
            pctRow('ابلاغ زیر {n} ثانیه', 'dispatchP2', ds.otherRankDispatchTarget, ds.otherRankDispatchValue, 60),
            pctRow('رسیدن زیر {n} دقیقه', 'arrivalP2WithinCity40', ds.otherRankArriveInCityTarget, ((ds.otherRankArriveInCityValue ?? 1) / 60), 40, 'city'),
            pctRow('رسیدن زیر {n} دقیقه', 'arrivalP2OutsideCity40', ds.otherRankArriveOutOfCityTarget, ((ds.otherRankArriveOutOfCityValue ?? 1) / 60), 40, 'rural')
          ]
        },
        {
          ...base[2],
          rows: [
            {
              label: 'بدون فاقدی',
              metric: 'coverage',
              kind: 'percent',
              goalText: '٪' + faNum(covGood) + ' و بالاتر',
              good: covGood,
              warn: Math.round(covGood * redRatio * 10) / 10,
              markerAt: covGood
            },
            cntRow('تأخیر حرکت بالای {n} دقیقه', 'movingDelay', ((ds.movingDelay ?? 1) / 60), pos(ds.yellowHigherThan), pos(ds.redHigherThan), 2),
            cntRow('بالین بالای {n} دقیقه', 'sceneStayDelay', ((ds.patientWaiting ?? 1) / 60), pos(ds.yellowHigherThan), pos(ds.redHigherThan), 20),
            cntRow('بیمارستان بالای {n} دقیقه', 'hospitalDelay', ((ds.hospitalWaiting ?? 1) / 60), pos(ds.yellowHigherThan), pos(ds.redHigherThan), 30)
          ]
        }
      ]
    }
  }

  // زمان‌های کلیدی
  const ta = setting.dispatchTimeAverageSetting
  if (ta) {
    const over = 1 + orDef(pos(ta.changeColorTarget), 15) / 100
    const goals = {
      responseCityAvg: pos(ta.responseTimeInCityTarget) !== null && pos(ta.responseTimeInCityTarget),
      responseRuralAvg: pos(ta.responseTimeOutOfCityTarget) !== null && pos(ta.responseTimeOutOfCityTarget),
      dispatchToMoveAvg: pos(ta.dispatchToMoveTarget) !== null && pos(ta.dispatchToMoveTarget),
      patientWaitAvg: pos(ta.patientWaiting) !== null && pos(ta.patientWaiting),
      hospitalWaitAvg: pos(ta.hospitalWaiting) !== null && pos(ta.hospitalWaiting)
    }
    out.times = DEFAULT_RULES.times.map(t => {
      const g = goals[t.metric]
      return g ? { ...t, goalSec: g, warnSec: g * over } : t
    })
  }
  return out
}

const computeStatusKey = (L, rules) => {
  if (!L.total) return 'normal'
  const pendingTotal = L.pending.r + L.pending.y + L.pending.g + L.pending.w
  if (rules.fleet.emergencyWhenPendingExceedsAvailable && pendingTotal > L.availableCodes) return 'emergency'
  return levelByPercent((L.availableCodes / L.total) * 100, rules.fleet.levels)
}

const emptyLive = () => ({
  total: 0, availableCodes: 0, other: 0, outOfService: 0,
  pending: { r: 0, y: 0, g: 0, w: 0 },
  oldestSince: { r: null, y: null, g: null, w: null },
  timestamp: new Date(0), byType: null, active: null
})
const emptyAgg = () => ({
  timestamp: new Date(), dispatchedCount: 0,
  dispatchP1: 0, arrivalP1WithinCity15: 0, arrivalP1OutsideCity15: 0, dispatchP2: 0, arrivalP2WithinCity40: 0, arrivalP2OutsideCity40: 0,
  coverage: 0, hospitalDelay: 0, movingDelay: 0, sceneStayDelay: 0,
  responseCityAvg: 0, responseRuralAvg: 0, dispatchToMoveAvg: 0, patientWaitAvg: 0, hospitalWaitAvg: 0, zoneRecords: []
})

import throttle from 'lodash/throttle';
import mergeWith from 'lodash/mergeWith';
import cloneDeep from 'lodash/cloneDeep';
import Shared from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import ShearedMixin from '@/Mixins/Shared.js';
import { toPersianDigits } from '@/utils/utils'
export default {
  name: 'DispatchDashboard',
  title: 'داشبورد 800',
  mixins: [Shared, DashboardMixin, ShearedMixin],
  created() {
    this.$root.$refs.DashboardsMain800 = this;

    this.throttledVehiclesReadiness = throttle(this.getDataVehiclesReadiness, 4000, {
      leading: true,
      trailing: true,
    });
    this.$mainSignalr.bus.$on('VehicleReadiness', this.throttledVehiclesReadiness);
    this.$mobileSignalr.bus.$on('VehicleReadiness', this.throttledVehiclesReadiness);

    this.throttledAwaitingMissions = throttle(this.getDataAwaitingMissions, 4000, {
      leading: true,
      trailing: true,
    });
    this.$mainSignalr.bus.$on('TopList800', this.throttledAwaitingMissions);
    this.$mobileSignalr.bus.$on('TopList800', this.throttledAwaitingMissions);

    this.throttledCurrentMissionsByRank = throttle(this.getDataCurrentMissionsByRank, 4000, {
      leading: true,
      trailing: true,
    });
    this.$mainSignalr.bus.$on('CurrentMissionsCount', this.throttledCurrentMissionsByRank);
    this.$mobileSignalr.bus.$on('CurrentMissionsCount', this.throttledCurrentMissionsByRank);
  },
  data() {
    return {
      zoneView: 'chart',//'card' or 'chart'
      logo: require('@/assets/images/SetareHayat.png'),
      icons: Object.freeze(ICONS),
      liveState: emptyLive(),
      aggregate: emptyAgg(),
      liveZones: null,
      rules: cloneDeep(DEFAULT_RULES),
      refreshCountdownSec: 60,
      now: new Date(),

      clockOffset: null,

      shiftStartDate: null,
      scale: 1,
      ox: 0,
      oy: 0,

      refreshTimerInMinute: 1,
      connState: 'Disconnected',

      focusedPanel: null, // null | 'sla' | 'zones' | 'times'

      vehicleReadinessRefreshInFlight: false,
      vehicleReadinessRefreshPending: false,
      vehicleReadinessCache: null,

      awaitingMissionsRefreshInFlight: false,
      awaitingMissionsRefreshPending: false,
      awaitingMissionsCache: null,

      missionsByRankRefreshInFlight: false,
      missionsByRankRefreshPending: false,
      missionsByRankCache: null,

    }
  },
  computed: {
    pendingRedCountFormatted() {
      const count = this.pendingTiles?.filter(i => i?.key == "r")?.count ?? 0
      return toPersianDigits(count)
    },
    /* ── سطح وضعیت ── */
    statusKey() { return computeStatusKey(this.liveState, this.rules) },
    statusUi() {
      const style = this.levelStyle(this.statusKey)
      return { ...style, softBackground: style.softBackground || style.color + '1f', blink: !!style.blink }
    },
    stateColors() { return this.rules.stateColors },
    inMissionCount() {
      const L = this.liveState
      return L.total - L.availableCodes - L.other - L.outOfService
    },
    availPercent() {
      const L = this.liveState
      return L.total ? (L.availableCodes / L.total) * 100 : 0
    },

    /* ── هدر ── */
    today() {
      return this.now.toLocaleDateString('fa-IR', { weekday: 'long', month: 'long', day: 'numeric' })
    },
    clock() { return fmtTime(this.now) },
    lastLiveSignalAt() { return fmtTime(this.liveState.timestamp) },
    lastAggregateAt() { return fmtTime(this.aggregate.timestamp) },
    connLabel() { return this.connState === 'Connected' ? 'اتصال زنده' : 'قطع ارتباط با سرور' },
    connColor() { return this.connState === 'Connected' ? '#4ade80' : '#ff6b6b' },
    stageTransform() { return `translate(${this.ox}px, ${this.oy}px) scale(${this.scale})` },

    /* ── آمادگی ناوگان ── */
    availableCodes() { return faNum(this.liveState.availableCodes) },
    totalCodesFmt() { return faNum(this.liveState.total) },
    availablePercentFmt() { return faNum(Math.round(this.availPercent)) + '٪' },
    ringBackground() {
      const p = Math.min(100, this.availPercent) + '%'
      return `conic-gradient(${this.statusUi.color} 0 ${p}, #1a2b55 ${p} 100%)`
    },
    fleet() {
      return [
        { label: 'در ماموریت :', value: faNum(this.inMissionCount) },
        { label: '10-7 :', value: faNum(this.liveState.outOfService) }
      ]
    },
    vehicleTypeRows() {
      const L = this.liveState
      let rows
      if (L.byType) {
        rows = L.byType.map(vt => ({ label: vt.label, ready: vt.ready, total: vt.total }))
      } else {
        rows = VEHICLE_TYPES.map((vt) => ({ label: vt.label, ready: 0, total: 0 }))
      }
      return rows.map(vt => {
        const levels = this.rules.vehicleTypeLevels || this.rules.fleet.levels
        const s = this.levelStyle(levelByPercent((vt.ready / (vt.total || 1)) * 100, levels))
        return {
          label: vt.label,
          ready: faNum(vt.ready),
          total: faNum(vt.total),
          color: s.color,
          width: (vt.ready / (vt.total || 1)) * 100 + '%',
          foreground: this.rules.fleet.zeroReadyIsDanger && vt.ready === 0 ? this.stateColors.r.color : '#eaf0fd'
        }
      })
    },

    /* ── در انتظار اعزام ── */
    waitingSecondsByRank() {
      const w = {}
      TRIAGE_LEVELS.forEach(t => {
        const oldest = this.liveState.oldestSince[t.key]
        w[t.key] = oldest ? (this.now.getTime() - oldest) / 1000 : 0
      })
      return w
    },
    pendingTotal() {
      const p = this.liveState.pending
      return p.r + p.y + p.g + p.w
    },
    pendingTotalFmt() { return faNum(this.pendingTotal) },
    pendingAlert() {
      const p = this.liveState.pending
      return (this.rules.pending.alertRanks || []).some(k => p[k] > 0)
    },
    pendingColor() {
      if (this.pendingTotal === 0) return '#fff'
      return this.pendingAlert ? this.stateColors.r.color : this.stateColors.y.color
    },
    pendingBackground() { return this.levelStyle(this.pendingAlert ? 'emergency' : 'normal').background },
    pendingBorder() { return this.levelStyle(this.pendingAlert ? 'emergency' : 'normal').border },
    maxWaitSec() { return Math.max(...Object.values(this.waitingSecondsByRank)) },
    maxWait() { return fmtDuration(this.maxWaitSec) },
    maxWaitColor() {
      const sev = severityByAbove(this.maxWaitSec, this.rules.maxWait)
      return sev ? this.stateColors[sev].color : '#fff'
    },
    pendingTiles() {
      const L = this.liveState
      const alertRanks = this.rules.pending.alertRanks || []
      const alertBorder = this.levelStyle('emergency').border
      return TRIAGE_LEVELS.map(t => {
        const count = L.pending[t.key]
        const isAlert = alertRanks.includes(t.key) && count > 0
        return {
          ...t,
          count: faNum(count),
          detail: count ? fmtDuration(this.waitingSecondsByRank[t.key]) : '—',
          background: isAlert ? this.rules.pending.alertTileBackground : '#0a1530',
          border: isAlert ? alertBorder : '#1a2b55',
          foreground: count ? (isAlert ? this.stateColors.r.color : '#fff') : '#5b6f99'
        }
      })
    },

    /* ── فوریت‌های جاری ── */
    activeByRank() {
      if (this.liveState.active) return this.liveState.active
      const b = this.inMissionCount
      const a = { r: Math.round(b * 0.18), y: Math.round(b * 0.34), g: Math.round(b * 0.33) }
      a.w = Math.max(0, b - a.r - a.y - a.g)
      return a
    },
    activeTotalFmt() { return faNum(this.liveState?.active?.totalMissions ?? 0) },
    activeTiles() {
      const b = Math.max(1, this.inMissionCount)
      return TRIAGE_LEVELS.map(t => ({
        ...t,
        count: faNum(this.activeByRank[t.key]),
        share: faNum(Math.round((this.activeByRank[t.key] / b) * 100)) + '٪',
        width: (this.activeByRank[t.key] / b) * 100 + '%'
      }))
    },

    /* ── شیفت ── */
    shift() {
      const hr = this.now.getHours()
      return hr >= 23 || hr < 7 ? SHIFTS[2] : hr >= 15 ? SHIFTS[1] : SHIFTS[0]
    },
    shiftStart() {
      if (this.shiftStartDate) {
        const d = new Date(this.shiftStartDate)
        if (!isNaN(d)) return pad2(d.getHours()) + ':' + pad2(d.getMinutes())
      }
      return pad2(this.shift.start) + ':۰۰'
    },
    dispatchedCount() { return faNum(this.aggregate.dispatchedCount) },
    effectiveRefreshSec() {
      const minutes = Number(this.refreshTimerInMinute)
      return (isFinite(minutes) && minutes > 0 ? minutes : 1)
    },
    countdown() { return faNum(Math.min(this.refreshCountdownSec, this.effectiveRefreshSec)) },
    progress() {
      const iv = this.effectiveRefreshSec
      return ((iv - Math.min(this.refreshCountdownSec, iv)) / iv) * 100 + '%'
    },

    /* ── سطح سرویس ── */
    slaGroups() {
      const A = this.aggregate
      const colors = this.stateColors
      return ((this.rules.sla && this.rules.sla.groups) || []).map(g => ({
        title: g.title,
        color: g.color,
        display: g.display || 'bars',
        rows: (g.rows || []).map(r => {
          const value = Number(A[r.metric]) || 0
          const st = colors[stateByThreshold(value, r)]
          return {
            label: r.label,
            goal: r.goalText || '',
            hasGoal: !!r.goalText,
            value: r.kind === 'count' ? faNum(value) : faNum(value) + '٪',
            width: clamp(value, 0, 100) + '%',
            markerPosition: clamp(Number(r.markerAt != null ? r.markerAt : r.good) || 0, 0, 100) + '%',
            isCity: r.area === 'city',
            isRural: r.area === 'rural',
            color: st.color,
            softBackground: st.softBackground,
            statusName: st.name
          }
        })
      }))
    },
    slaPriorityGroups() { return this.slaGroups.filter(g => g.display !== 'tiles') },
    slaCapacityRows() {
      const g = this.slaGroups.find(x => x.display === 'tiles')
      return g ? g.rows : []
    },

    /* ── مناطق ── */
    zoneList() {
      return this.liveZones || []
    },
    zoneDisplayRows() {
      const levels = this.rules.zoneLevels || this.rules.fleet.levels
      return this.zoneList.map(z => {
        const total = z.total || 1
        const statusKey = levelByPercent((z.ready / total) * 100, levels)
        const s = this.levelStyle(statusKey)
        const normal = statusKey === 'normal'
        const sev = severityByAbove(z.resp, this.rules.zoneResponse)
        return {
          name: z.name,
          readyN: z.ready, busyN: z.busy, outOfServiceN: z.outOfService,
          total: faNum(z.total), ready: faNum(z.ready), busy: faNum(z.busy), outOfService: faNum(z.outOfService),
          pct: faNum(Math.round((z.ready / total) * 100)) + '٪',
          resp: fmtDuration(z.resp),
          respColor: sev ? this.stateColors[sev].color : '#eaf0fd',
          statusKey,
          color: s.color, statusName: s.name, softBackground: s.color + '29',
          readinessRatio: z.ready / total,
          tileBackground: normal ? '#0a1530' : s.color + '1a',
          tileBorder: normal ? '#1a2b55' : s.color + '99'
        }
      })
    },
    sortedZones() { return [...this.zoneDisplayRows].sort((a, b) => a.readinessRatio - b.readinessRatio) },
    viewZones() { return this.zoneLayout.many ? this.sortedZones : this.zoneDisplayRows },
    zoneLayout() {
      const zoneCount = this.zoneList.length
      const many = zoneCount > 10
      const chart = this.zoneView === 'chart'
      const two = chart && zoneCount > 8
      return {
        zoneCount, many, chart, two,
        basis: zoneCount <= 6 ? '30%' : zoneCount <= 10 ? '22%' : '17%',
        tilePad: many ? '8px 12px' : zoneCount <= 3 ? '18px 20px' : '12px 16px',
        nameFont: many ? '17px' : zoneCount <= 6 ? '21px' : '19px',
        readyFont: many ? '28px' : zoneCount <= 3 ? '60px' : zoneCount <= 6 ? '42px' : '32px',
        barH: two ? (zoneCount > 14 ? '22px' : '28px') : zoneCount <= 3 ? '44px' : zoneCount <= 6 ? '32px' : '24px',
        segH: zoneCount <= 3 ? '44px' : zoneCount <= 6 ? '34px' : '28px',
        segMin: zoneCount <= 6 ? '50px' : '34px',
        segFont: zoneCount <= 6 ? '17px' : '15px',
        icons: zoneCount <= 6,
        chartCols: two ? 'repeat(2,minmax(0,1fr))' : 'minmax(0,1fr)',
        chartRows: `repeat(${two ? Math.ceil(zoneCount / 2) : zoneCount},minmax(0,1fr))`,
        rowCols: two ? '96px minmax(0,1fr) 62px' : '100px minmax(0,1fr) 76px'
      }
    },
    zoneCountLabel() { return `${faNum(this.zoneLayout.zoneCount)} منطقه` },
    zoneLevelSummary() {
      return Object.keys(this.rules.styles).reverse()
        .map(k => {
          const style = this.levelStyle(k)
          const count = this.zoneDisplayRows.filter(z => z.statusKey === k).length
          return { value: faNum(count), color: style.color, softBackground: style.color + '29', count }
        })
        .filter(s => s.count > 0)
    },
    recommendation() {
      const sorted = this.sortedZones
      const worst = sorted[0] || { name: '' }
      const best = sorted[sorted.length - 1] || { name: '' }
      const color = this.statusUi.color
      const base = (this.rules.recommendations || {})[this.statusKey] || { title: '', message: '' }
      return {
        title: base.title,
        message: fillTokens(base.message, { best: best.name, worst: worst.name, redPending: faNum(Math.max(1, this.liveState.pending.r)) }),
        color, background: color + '1f', border: color + '66'
      }
    },

    /* ── زمان‌های کلیدی ── */
    timeMetrics() {
      const A = this.aggregate
      return (this.rules.times || []).map(t => {
        const value = Number(A[t.metric]) || 0
        const goal = Number(t.goalSec) || 0
        const warn = Number(t.warnSec) || goal * 1.15
        const max = Number(t.scaleMaxSec) || goal * 1.6 || 1
        const st = this.stateColors[stateByThreshold(value, { good: goal, warn, direction: 'lowerIsBetter' })]
        return {
          label: t.label,
          value: fmtDuration(value),
          goal: fmtDuration(goal),
          color: st.color,
          width: Math.min(100, (value / max) * 100) + '%',
          markerPosition: (goal / max) * 100 + '%'
        }
      })
    }
  },
  mounted() {
    this.mounteLoding();

    this.setHomeMenuHidden(true)
    this.fit()
    if (typeof ResizeObserver !== 'undefined') {
      this.ro = new ResizeObserver(this.fit)
      this.ro.observe(this.$refs.host)
    } else {
      window.addEventListener('resize', this.fit)
    }
    this.timer = setInterval(this.tick, 1000)

    window.addEventListener('keydown', this.onKeydown)

    const st = this.$mainSignalr?.connection?.state
    if (st) this.connState = st

    this.getDataVehiclesReadiness();
    this.getDataAwaitingMissions();
    this.getDataCurrentMissionsByRank();

  },
  beforeDestroy() {
    this.setHomeMenuHidden(false)
    clearInterval(this.timer)
    clearTimeout(this.sig)
    if (this.ro) this.ro.disconnect()
    window.removeEventListener('resize', this.fit)
    window.removeEventListener('keydown', this.onKeydown)

    this.$mainSignalr.bus.$off('VehicleReadiness', this.throttledVehiclesReadiness);
    this.$mobileSignalr.bus.$off('VehicleReadiness', this.throttledVehiclesReadiness);
    this.throttledVehiclesReadiness.cancel();

    this.$mainSignalr.bus.$off('TopList800', this.throttledAwaitingMissions);
    this.$mobileSignalr.bus.$off('TopList800', this.throttledAwaitingMissions);
    this.throttledAwaitingMissions.cancel();

    this.$mainSignalr.bus.$off('CurrentMissionsCount', this.throttledCurrentMissionsByRank);
    this.$mobileSignalr.bus.$off('CurrentMissionsCount', this.throttledCurrentMissionsByRank);
    this.throttledCurrentMissionsByRank.cancel();

    delete this.$root.$refs.DashboardsMain800;
  },

  methods: {
    mounte: function () {
      this.fetchMain800()
    },
    setHomeMenuHidden(hidden) {
      const home = this.$root.$refs.Home
      if (home && home.setMenuHidden) home.setMenuHidden(hidden)
    },
    openMenu() {
      const home = this.$root.$refs.Home
      if (home && home.openMenu) home.openMenu()
    },
    fit() {
      const el = this.$refs.host
      if (!el) return
      const w = el.clientWidth
      const h = el.clientHeight
      const s = Math.min(w / 1920, h / 1080)
      this.scale = s
      this.ox = (w - 1920 * s) / 2
      this.oy = (h - 1080 * s) / 2
    },

    toggleFocus(panel) {
      this.focusedPanel = this.focusedPanel === panel ? null : panel
    },
    exitFocus() {
      this.focusedPanel = null
    },
    onKeydown(e) {
      if (e.key === 'Escape' && this.focusedPanel) {
        e.preventDefault()
        this.exitFocus()
      }
    },

    tick() {
      const st = this.$mainSignalr?.connection?.state
      if (st) this.connState = st
      this.now = this.serverNow()
      const iv = this.effectiveRefreshSec
      if (this.refreshCountdownSec <= 1) {
        this.refreshCountdownSec = iv
        this.fetchMain800()
      } else {
        this.refreshCountdownSec = Math.min(this.refreshCountdownSec, iv) - 1
      }
    },

    applyAggregate(payload) {
      this.aggregate = { ...emptyAgg(), ...payload, timestamp: payload.timestamp ? new Date(payload.timestamp) : new Date() }
      this.refreshCountdownSec = this.effectiveRefreshSec
    },
    syncClock(serverDate) {
      const d = serverDate ? new Date(serverDate) : null
      if (!d || isNaN(d)) return
      this.clockOffset = d.getTime() - Date.now()
      this.now = this.serverNow()
    },
    serverNow() {
      return new Date(Date.now() + (this.clockOffset || 0))
    },
    levelStyle(key) {
      return this.rules.styles[key] || this.rules.styles.normal
    },
    applyRules(incoming) {
      if (!incoming || typeof incoming !== 'object') return
      this.rules = mergeWith({}, DEFAULT_RULES, incoming, (o, src) => (Array.isArray(src) ? src : undefined))
    },

    fetchMain800: function (retried) {
      return this.$store.dispatch('getDashboardMain800').then(() => {
        const dashboard = this.$store.state.dashboardModule;
        if (dashboard.successFlag) {

          const data = dashboard.dashboardMain800;

          const refreshMin = Number(data?.setting?.refreshTime ?? data?.refreshTimerInMinute)
          if (refreshMin > 0) {
            this.refreshTimerInMinute = refreshMin;
          }

          const aggPayload = {}
          if (data.serviceLevel) {
            const serviceLevel = data.serviceLevel
            aggPayload.dispatchP1 = serviceLevel.redRankDispatchPercentage ?? 0
            aggPayload.dispatchP2 = serviceLevel.otherRanksDispatchPercentage ?? 0
            aggPayload.arrivalP1WithinCity15 = serviceLevel.redRankArriveToLocationWithinCityPercentage ?? 0
            aggPayload.arrivalP1OutsideCity15 = serviceLevel.redRankArriveToLocationOutOfCityPercentage ?? 0
            aggPayload.arrivalP2WithinCity40 = serviceLevel.otherRankArriveToLocationWithinCityPercentage ?? 0
            aggPayload.arrivalP2OutsideCity40 = serviceLevel.otherRankArriveToLocationOutOfCityPercentage ?? 0
            aggPayload.coverage = serviceLevel.withoutLackOfCodePercentage ?? 0
            aggPayload.movingDelay = serviceLevel.movingDelay ?? 0
            aggPayload.sceneStayDelay = serviceLevel.patientWaitingDelay ?? 0
            aggPayload.hospitalDelay = serviceLevel.hospitalWaitingDelay ?? 0
          }
          if (data.timesAverage) {
            const timeAverages = data.timesAverage
            aggPayload.responseCityAvg = timeAverages.responseTimeWithinCityAverage ?? 0
            aggPayload.responseRuralAvg = timeAverages.responseTimeOutOfCityAverage ?? 0
            aggPayload.dispatchToMoveAvg = timeAverages.dispatchTillMoveFromStationAverage ?? 0
            aggPayload.patientWaitAvg = timeAverages.patientWaitingAverage ?? 0
            aggPayload.hospitalWaitAvg = timeAverages.hospitalWaitingAverage ?? 0
          }
          aggPayload.dispatchedCount = data.totalMissions ?? 0
          if (data.currentDate) {
            aggPayload.timestamp = new Date(data.currentDate)
            this.syncClock(data.currentDate)
          }
          if (data.shiftStartDate) this.shiftStartDate = data.shiftStartDate
          if (data.setting) this.applyRules(rulesFromSetting(data.setting))
          this.applyAggregate(aggPayload)
          if (data.zones && data.zones.length) {
            this.liveZones = data.zones.map(z => ({
              name: z.title || '—',
              ready: z.readyCodes ?? 0,
              busy: z.onMissionCodes ?? 0,
              outOfService: z.outOfServiceCodes ?? 0,
              total: (z.readyCodes ?? 0) + (z.onMissionCodes ?? 0) + (z.outOfServiceCodes ?? 0),
              resp: z.responseTimeInSeconds ?? 0
            }))
          } else {
            this.liveZones = null
          }

          return data;
        }
        if (dashboard.errorStatus && retried !== true) {
          return this.$store.dispatch('refreshToken').then(() => {
            if (this.$store.state.userModule.successFlag) {
              return this.fetchMain800(true);
            }
            this.$router.push({ name: 'login' });
            throw new Error('unauthorized');
          });
        }
        throw new Error(dashboard.error || 'dashboard error');
      });
    },

    applyVehiclesReadiness(data) {
      const total = Number(data.totalCodes) || 0
      const availableCodes = Number(data.readyCodes) || 0
      const outOfService = Number(data.outOfServiceCodes) || 0
      const mission = Number(data.missionCodes) || 0
      this.liveState = {
        ...this.liveState,
        total,
        availableCodes,
        outOfService,

        other: Math.max(0, total - availableCodes - outOfService - mission),
        byType: [
          { label: 'آمبولانس', ready: Number(data.readyAmbulances) || 0, total: Number(data.totalAmbulances) || 0 },
          { label: 'موتورلانس', ready: Number(data.readyMotors) || 0, total: Number(data.totalMotors) || 0 },
          { label: 'سایر', ready: Number(data.readyOtherCodes) || 0, total: Number(data.totalOtherCodes) || 0 }
        ],
        timestamp: data.currentDate ? new Date(data.currentDate) : new Date()
      }
    },
    applyAwaitingMissions(data) {
      const now = Date.now()
      const mkOldestSince = (count, sec) => {
        const n = Number(count) || 0
        const s = Number(sec) || 0
        return n > 0 && s > 0 ? now - s * 1000 : null
      }
      this.liveState = {
        ...this.liveState,
        pending: {
          r: Number(data.totalRedMissions) || 0,
          y: Number(data.totalYellowMissions) || 0,
          g: Number(data.totalGreenMissions) || 0,
          w: Number(data.totalWhiteMissions) || 0
        },
        oldestSince: {
          r: mkOldestSince(data.totalRedMissions, data.longestRedMissionInSeconds),
          y: mkOldestSince(data.totalYellowMissions, data.longestYellowMissionInSeconds),
          g: mkOldestSince(data.totalGreenMissions, data.longestGreenMissionInSeconds),
          w: mkOldestSince(data.totalWhiteMissions, data.longestWhiteMissionInSeconds)
        },
        timestamp: data.currentDate ? new Date(data.currentDate) : new Date()
      }
    },
    applyCurrentMissionsByRank(data) {
      this.liveState = {
        ...this.liveState,
        active: {
          r: Number(data.totalRedMissions) || 0,
          y: Number(data.totalYellowMissions) || 0,
          g: Number(data.totalGreenMissions) || 0,
          w: Number(data.totalWhiteMissions) || 0,
          totalMissions: Number(data.totalMissions) || 0
        },
        timestamp: data.currentDate ? new Date(data.currentDate) : new Date()
      }

    },
    getDataVehiclesReadiness: async function () {
      if (this.vehicleReadinessRefreshInFlight) {
        this.vehicleReadinessRefreshPending = true;
        return;
      }
      this.vehicleReadinessRefreshInFlight = true;
      try {
        const res = await this.getVehiclesReadinessFunction();

        const data = res && res.data && res.value === undefined ? res.data : res;
        if (!data) return;
        const t = data.currentDate ? new Date(data.currentDate).getTime() : 0;

        if (this.vehicleReadinessCache && isFinite(t) && t < this.vehicleReadinessCache.t) return;
        this.vehicleReadinessCache = { value: data, t: isFinite(t) ? t : 0 };
        this.applyVehiclesReadiness(data);

      } catch (error) {
        console.log('getDataVehiclesReadiness refresh error:', error);
      } finally {
        this.vehicleReadinessRefreshInFlight = false;
        if (this.vehicleReadinessRefreshPending) {
          this.vehicleReadinessRefreshPending = false;
          this.getDataVehiclesReadiness();
        }
      }
    },
    getDataAwaitingMissions: async function () {
      if (this.awaitingMissionsRefreshInFlight) {
        this.awaitingMissionsRefreshPending = true;
        return;
      }
      this.awaitingMissionsRefreshInFlight = true;
      try {
        const res = await this.getAwaitingMissionsFunction();

        const data = res && res.data && res.value === undefined ? res.data : res;
        if (!data) return;
        const t = data.currentDate ? new Date(data.currentDate).getTime() : 0;

        if (this.awaitingMissionsCache && isFinite(t) && t < this.awaitingMissionsCache.t) return;
        this.awaitingMissionsCache = { value: data, t: isFinite(t) ? t : 0 };
        this.applyAwaitingMissions(data);
      } catch (error) {
        console.log('getDataAwaitingMissions refresh error:', error);
      } finally {
        this.awaitingMissionsRefreshInFlight = false;
        if (this.awaitingMissionsRefreshPending) {
          this.awaitingMissionsRefreshPending = false;
          this.getDataAwaitingMissions();
        }
      }
    },
    getDataCurrentMissionsByRank: async function () {
      if (this.missionsByRankRefreshInFlight) {
        this.missionsByRankRefreshPending = true;
        return;
      }
      this.missionsByRankRefreshInFlight = true;
      try {
        const res = await this.getCurrentMissionsByRankFunction();

        const data = res && res.data && res.value === undefined ? res.data : res;
        if (!data) return;
        const t = data.currentDate ? new Date(data.currentDate).getTime() : 0;

        if (this.missionsByRankCache && isFinite(t) && t < this.missionsByRankCache.t) return;
        this.missionsByRankCache = { value: data, t: isFinite(t) ? t : 0 };
        this.applyCurrentMissionsByRank(data);

      } catch (error) {
        console.log('getDataCurrentMissionsByRank refresh error:', error);
      } finally {
        this.missionsByRankRefreshInFlight = false;
        if (this.missionsByRankRefreshPending) {
          this.missionsByRankRefreshPending = false;
          this.getDataCurrentMissionsByRank();
        }
      }
    },
  }
}
</script>

<style scoped>
.ad-host {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #040a18;
  overflow: hidden;
  /* font-family: Vazirmatn, system-ui, sans-serif; */
}

.ad-host *,
.ad-host *::before,
.ad-host *::after {
  box-sizing: border-box;
}

.ad-stage {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  transform-origin: 0 0;
  background: #060d20;
  color: #eaf0fd;
  /* font-family: Vazirmatn, system-ui, sans-serif; */
  padding: 24px 32px;
  display: grid;
  grid-template-rows: 80px 340px minmax(0, 1fr);
  gap: 20px;
}

.ad-stage_full {
  grid-template-rows: 80px minmax(0, 1fr) !important;
}

.ad-stage b {
  font-weight: 700;
}

@keyframes ad-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

@keyframes ad-blink {
  50% {
    opacity: 0.55;
  }
}

.ad-pulse {
  background: #22c55e;
  animation: ad-pulse 2s infinite;
}

.ad-blink {
  animation: ad-blink 1s infinite;
}

.ad-row {
  display: flex;
  align-items: center;
}

.ad-row--20 {
  gap: 20px;
}

.ad-row--36 {
  gap: 36px;
}

.ad-dot {
  border-radius: 50%;
  display: inline-block;
}

.ad-dot--12 {
  width: 12px;
  height: 12px;
}

.ad-dot--10 {
  width: 10px;
  height: 10px;
}

.ad-dot--noshrink {
  flex: none;
}

.ad-sq10 {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: #7fb0ff;
}

.ad-sq12 {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: #5b6f99;
}

.ad-sq14 {
  width: 14px;
  height: 14px;
  border-radius: 4px;
}

.ad-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ad-icon {
  flex: none;
  display: grid;
  place-items: center;
  background: #13203f;
}

.ad-icon--48 {
  width: 48px;
  height: 48px;
  border-radius: 14px;
}

.ad-icon--42 {
  width: 42px;
  height: 42px;
  border-radius: 12px;
}

.ad-icon--28 {
  width: 28px;
  height: 28px;
  border-radius: 8px;
}

.ad-icon--blue {
  background: #1a3166;
}

.ad-grid4 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.ad-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: #0b1630;
  border: 1px solid #172447;
  border-radius: 18px;
  padding: 0 28px;
}

.ad-logo-btn {
  cursor: pointer;
  transition: transform 0.15s;
}

.ad-logo-btn:hover {
  transform: scale(1.12);
}

.ad-title {
  font-size: 32px;
  font-weight: 800;
}

.ad-subtitle {
  font-size: 20px;
  font-weight: 500;
}

.ad-date {
  font-size: 22px;
  color: #93a6cf;
}

.ad-level-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 700;
  padding: 6px 18px;
  border-radius: 30px;
}

.ad-conn {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 21px;
}

.ad-clock {
  font-size: 34px;
  font-weight: 700;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.ad-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

.ad-section-head {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
}

.ad-section-title {
  font-size: 24px;
  font-weight: 800;
}

.ad-section-title--live {
  color: #fff;
}

.ad-section-title--shift {
  color: #c9d6f2;
}

.ad-section-sub {
  font-size: 20px;
  color: #93a6cf;
}

.ad-section-line {
  flex: 1;
  height: 1px;
  background: #24407a;
  margin: 0 12px;
}

.ad-section-meta {
  font-size: 19px;
  color: #93a6cf;
  font-variant-numeric: tabular-nums;
}

.ad-section-meta--nowrap {
  white-space: nowrap;
}

.ad-section-meta-val {
  color: #c9d6f2;
  font-weight: 700;
}

.ad-progress {
  flex: 1;
  height: 6px;
  border-radius: 4px;
  background: #13203f;
  margin: 0 12px;
  overflow: hidden;
  display: flex;
}

.ad-progress-fill {
  height: 100%;
  border-radius: 4px;
  background: #5b7fc7;
  transition: width 1s linear;
}

.ad-live-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  gap: 20px;
  grid-template-columns: minmax(0, 4.2fr) minmax(0, 4.4fr) minmax(0, 4.4fr);
}

.ad-card {
  border: 2px solid transparent;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 0;
  overflow: hidden;
}

.ad-card--ready {
  padding: 20px 28px;
  gap: 12px;
  transition: background 0.4s;
}

.ad-card--pend {
  padding: 22px 26px;
  gap: 14px;
}

.ad-card--act {
  padding: 22px 26px;
  gap: 8px;
  background: #0f1f45;
  border: 1px solid #24407a;
}

.ad-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-card-title {
  display: flex;
  align-items: center;
  gap: 14px;
}

.ad-card-title-text {
  font-size: 28px;
  font-weight: 700;
}

/* آمادگی ناوگان */
.ad-fleet-wrap {
  display: flex;
  align-items: center;
  gap: 18px;
}

.ad-fleet {
  display: flex;
  gap: 16px;
  font-size: 17px;
  color: #93a6cf;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ad-fleet b {
  color: #eaf0fd;
  font-size: 20px;
}

.ad-pill {
  font-size: 22px;
  font-weight: 800;
  padding: 6px 20px;
  border-radius: 30px;
}

.ad-ready-grid {
  display: grid;
  grid-template-columns: 168px minmax(0, 1fr);
  gap: 30px;
  align-items: center;
}

.ad-ring {
  width: 168px;
  height: 168px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  transition: background 0.6s;
}

.ad-ring-inner {
  width: 136px;
  height: 136px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ad-ring-cap {
  font-size: 16px;
  color: #a9badd;
}

.ad-ring-cap--b {
  font-size: 17px;
  font-variant-numeric: tabular-nums;
}

.ad-ring-num {
  font-size: 60px;
  font-weight: 900;
  line-height: 0.95;
  font-variant-numeric: tabular-nums;
}

.ad-types {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.ad-type {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ad-type-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.ad-type-name {
  font-size: 19px;
  color: #c9d6f2;
}

.ad-type-count {
  font-size: 16px;
  color: #93a6cf;
  font-variant-numeric: tabular-nums;
}

.ad-type-count b {
  font-size: 24px;
}

.ad-track8 {
  height: 8px;
  border-radius: 5px;
  background: #1a2b55;
  overflow: hidden;
}

.ad-track8-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.6s;
}

.ad-big56 {
  font-size: 56px;
  font-weight: 900;
  line-height: 0.9;
  font-variant-numeric: tabular-nums;
}

.ad-big56--white {
  color: #fff;
}

.ad-maxwait {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #0a1530;
  border-radius: 14px;
  padding: 6px 18px;
}

.ad-maxwait-label {
  font-size: 21px;
  color: #a9badd;
}

.ad-maxwait-val {
  font-size: 36px;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.ad-pend-tile {
  border: 2px solid transparent;
  border-radius: 14px;
  padding: 7px 14px;
  display: flex;
  flex-direction: column;
}

.ad-pend-tile-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 19px;
  font-weight: 700;
  color: #c9d6f2;
}

.ad-pend-tile-num {
  font-size: 40px;
  font-weight: 900;
  line-height: 1.05;
  font-variant-numeric: tabular-nums;
}

.ad-pend-tile-sub {
  font-size: 18px;
  color: #93a6cf;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.ad-act-bar-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ad-act-bar {
  display: flex;
  height: 14px;
  border-radius: 8px;
  overflow: hidden;
  gap: 3px;
}

.ad-act-bar-seg {
  height: 100%;
  transition: width 0.6s;
}

.ad-act-caption {
  font-size: 18px;
  color: #93a6cf;
}

.ad-act-tile {
  border-radius: 14px;
  background: #0a1530;
  border: 2px solid #1a2b55;
  border-top-width: 4px;
  padding: 8px 14px;
  display: flex;
  flex-direction: column;
}

.ad-act-tile-label {
  font-size: 19px;
  font-weight: 700;
  color: #c9d6f2;
}

.ad-act-tile-num {
  font-size: 44px;
  font-weight: 900;
  line-height: 1.05;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.ad-act-tile-sub {
  font-size: 18px;
  color: #93a6cf;
  font-variant-numeric: tabular-nums;
}

.ad-bottom-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  gap: 20px;
  grid-template-columns: minmax(0, 6fr) minmax(0, 7.4fr) minmax(0, 3.6fr);
}

.ad-panel {
  background: #0b1630;
  border: 1px solid #172447;
  border-radius: 20px;
  padding: 18px 24px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ad-panel--sla {
  gap: 4px;
}

.ad-panel--zones {
  gap: 10px;
}

.ad-panel--times {
  gap: 12px;
}

.ad-panel-title {
  font-size: 24px;
  font-weight: 700;
}

.ad-panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.ad-panel-head--sla {
  margin-bottom: 2px;
}

.ad-sla-grid {
  flex: 1;
  min-height: 0;
  margin-top: 6px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
}

.ad-sla-group {
  background: #0e1a38;
  border: 1px solid #172447;
  border-radius: 16px;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
}

.ad-sla-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
}

.ad-sla-row {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.ad-sla-row-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
}

.ad-sla-row-label {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 18px;
  color: #eaf0fd;
  white-space: nowrap;
}

.ad-sla-row-val {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.ad-sla-track {
  position: relative;
  height: 12px;
  border-radius: 6px;
  background: #172447;
}

.ad-sla-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  border-radius: 6px;
}

.ad-sla-marker {
  position: absolute;
  top: -4px;
  bottom: -4px;
  right: 90%;
  width: 3px;
  border-radius: 2px;
  background: #eaf0fd;
}

.ad-sla-row-bottom {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  color: #93a6cf;
}

.ad-sla-row-bottom span:last-child {
  font-weight: 700;
}

.ad-cap-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #7fb0ff;
  margin-top: 10px;
}

.ad-cap-title-sub {
  font-size: 15px;
  font-weight: 400;
  color: #93a6cf;
}

.ad-grid4--cap {
  margin-top: 6px;
}

.ad-cap-tile {
  border: 1px solid transparent;
  border-radius: 14px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ad-cap-val {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.ad-cap-label {
  font-size: 16px;
  color: #eaf0fd;
  line-height: 1.3;
  text-wrap: pretty;
}

.ad-cap-goal {
  font-size: 14px;
  color: #a9badd;
}

.ad-zone-count {
  font-size: 18px;
  color: #93a6cf;
}

.ad-zsum {
  display: flex;
  gap: 8px;
}

.ad-zsum-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 17px;
  font-weight: 800;
  padding: 3px 10px;
  border-radius: 30px;
  font-variant-numeric: tabular-nums;
}

.ad-rec {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  padding: 4px 14px;
  border-radius: 30px;
  white-space: nowrap;
  border: 1px solid transparent;
}

.ad-zcards {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-wrap: wrap;
  align-content: stretch;
  gap: 12px;
}

.ad-zcard {
  min-width: 0;
  min-height: 0;
  border: 2px solid transparent;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  overflow: hidden;
}

.ad-zcard-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ad-zcard-name-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ad-zcard-dot {
  width: 12px;
  height: 12px;
  flex: none;
  border-radius: 50%;
}

.ad-zcard-name {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ad-zcard-resp-wrap {
  display: flex;
  align-items: center;
  gap: 5px;
  flex: none;
  font-size: 17px;
  font-weight: 700;
}

.ad-zcard-ready {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-variant-numeric: tabular-nums;
}

.ad-zcard-ready-num {
  font-weight: 900;
  line-height: 1;
}

.ad-zcard-ready-cap {
  font-size: 16px;
  color: #93a6cf;
  white-space: nowrap;
}

.ad-zsegs {
  display: flex;
  gap: 3px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.ad-zseg {
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.ad-zseg--ready {
  color: #06101f;
}

.ad-zseg--busy {
  background: #4f8cff;
  color: #06101f;
}

.ad-zseg--oos {
  background: #5b6f99;
  color: #eaf0fd;
}

.ad-zcompact {
  flex: 1;
  min-height: 0;
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-auto-rows: minmax(0, 1fr);
}

.ad-zmini {
  min-width: 0;
  min-height: 0;
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 6px 8px;
  display: flex;
  gap: 8px;
  overflow: hidden;
}

.ad-zmini-bars {
  width: 30px;
  flex: none;
  display: flex;
  flex-direction: column-reverse;
  gap: 2px;
  font-size: 14px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.ad-zmini-bar {
  border-radius: 5px;
  display: grid;
  place-items: center;
}

.ad-zmini-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.ad-zmini-name {
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ad-zmini-ready-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
  white-space: nowrap;
}

.ad-zmini-ready {
  font-size: 28px;
  font-weight: 900;
  line-height: 1;
}

.ad-zmini-pct {
  font-size: 14px;
  font-weight: 700;
}

.ad-zmini-of {
  font-size: 13px;
  color: #93a6cf;
  white-space: nowrap;
}

.ad-zmini-resp {
  font-size: 14px;
  font-weight: 700;
  text-align: right;
}

.ad-zlegend {
  display: flex;
  gap: 18px;
  font-size: 16px;
  color: #93a6cf;
}

.ad-zlegend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ad-zlegend-last {
  margin-right: auto;
}

.ad-zchart {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px 24px;
}

.ad-zrow {
  display: grid;
  gap: 10px;
  align-items: center;
  font-variant-numeric: tabular-nums;
}

.ad-zrow-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
}

.ad-zrow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.ad-zrow-bar {
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  gap: 2px;
  background: #1a2b55;
}

.ad-zrow-seg {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  color: #06101f;
}

.ad-zrow-seg--ready {
  font-weight: 800;
}

.ad-zrow-seg--busy {
  background: #4f8cff;
  font-weight: 700;
}

.ad-zrow-seg--oos {
  background: #5b6f99;
  color: #eaf0fd;
  font-weight: 700;
}

.ad-zrow-resp {
  font-size: 19px;
  font-weight: 700;
  text-align: right;
}

.ad-times {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 4px;
}

.ad-time {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ad-time-label {
  font-size: 18px;
  color: #c9d6f2;
}

.ad-time-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.ad-time-val {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.ad-time-goal {
  font-size: 17px;
  color: #93a6cf;
  white-space: nowrap;
}

.ad-time-track {
  height: 10px;
  border-radius: 6px;
  background: #13203f;
  position: relative;
}

.ad-time-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  border-radius: 6px;
  transition: width 0.6s;
}

.ad-time-marker {
  position: absolute;
  top: -4px;
  width: 3px;
  height: 18px;
  border-radius: 2px;
  background: #eaf0fd;
}

/* ═══════════ Focus / Fullscreen panel ═══════════ */
.ad-focus-btn {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #13203f;
  border: 1px solid #24407a;
  color: #c9d6f2;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s, transform 0.1s;
}

.ad-focus-btn:hover {
  background: #1a3166;
  color: #fff;
  border-color: #5b7fc7;
}

.ad-focus-btn:active {
  transform: scale(0.96);
}

.ad-panel.is-hidden {
  display: none;
}

.ad-bottom-grid--focus {
  grid-template-columns: minmax(0, 1fr) !important;
  gap: 0;
}

.ad-stage--focus .ad-section--focus {
  grid-column: 1 / -1;
}

.ad-panel.is-fullscreen {
  padding: 28px 40px;
  gap: 20px;
}

.ad-panel.is-fullscreen .ad-panel-title {
  font-size: 34px;
}

.ad-panel.is-fullscreen .ad-icon--42 {
  width: 54px;
  height: 54px;
  border-radius: 16px;
}

.ad-panel.is-fullscreen .ad-focus-btn {
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

/* سطح سرویس */
.ad-panel--sla.is-fullscreen .ad-sla-grid {
  gap: 22px;
}

.ad-panel--sla.is-fullscreen .ad-sla-group {
  padding: 16px 24px;
  gap: 10px;
}

.ad-panel--sla.is-fullscreen .ad-sla-group-title {
  font-size: 26px;
}

.ad-panel--sla.is-fullscreen .ad-sla-row-label {
  font-size: 24px;
}

.ad-panel--sla.is-fullscreen .ad-sla-row-val {
  font-size: 44px;
}

.ad-panel--sla.is-fullscreen .ad-sla-track {
  height: 16px;
}

.ad-panel--sla.is-fullscreen .ad-sla-marker {
  top: -6px;
  bottom: -6px;
  width: 4px;
}

.ad-panel--sla.is-fullscreen .ad-sla-row-bottom {
  font-size: 20px;
}

.ad-panel--sla.is-fullscreen .ad-cap-title {
  font-size: 24px;
  margin-top: 16px;
}

.ad-panel--sla.is-fullscreen .ad-cap-title-sub {
  font-size: 20px;
}

.ad-panel--sla.is-fullscreen .ad-cap-tile {
  padding: 14px 18px;
  border-radius: 18px;
}

.ad-panel--sla.is-fullscreen .ad-cap-val {
  font-size: 42px;
}

.ad-panel--sla.is-fullscreen .ad-cap-label {
  font-size: 22px;
}

.ad-panel--sla.is-fullscreen .ad-cap-goal {
  font-size: 18px;
}

/* مناطق */
.ad-panel--zones.is-fullscreen .ad-zone-count {
  font-size: 24px;
}

.ad-panel--zones.is-fullscreen .ad-zsum-pill {
  font-size: 22px;
  padding: 5px 14px;
}

.ad-panel--zones.is-fullscreen .ad-rec {
  font-size: 24px;
  padding: 6px 18px;
}

.ad-panel--zones.is-fullscreen .ad-zcard {
  padding: 20px 24px !important;
  gap: 14px;
}

.ad-panel--zones.is-fullscreen .ad-zcard-name {
  font-size: 28px !important;
}

.ad-panel--zones.is-fullscreen .ad-zcard-resp-wrap {
  font-size: 22px;
}

.ad-panel--zones.is-fullscreen .ad-zcard-resp-wrap svg {
  width: 22px;
  height: 22px;
}

.ad-panel--zones.is-fullscreen .ad-zcard-ready-num {
  font-size: 64px !important;
}

.ad-panel--zones.is-fullscreen .ad-zcard-ready-cap {
  font-size: 22px;
}

.ad-panel--zones.is-fullscreen .ad-zsegs {
  font-size: 22px !important;
  height: 56px !important;
}

.ad-panel--zones.is-fullscreen .ad-zseg svg {
  width: 18px;
  height: 18px;
}

.ad-panel--zones.is-fullscreen .ad-zmini {
  padding: 12px 14px;
  gap: 14px;
}

.ad-panel--zones.is-fullscreen .ad-zmini-bars {
  width: 44px;
  font-size: 18px;
}

.ad-panel--zones.is-fullscreen .ad-zmini-name {
  font-size: 22px;
}

.ad-panel--zones.is-fullscreen .ad-zmini-ready {
  font-size: 44px;
}

.ad-panel--zones.is-fullscreen .ad-zmini-pct {
  font-size: 20px;
}

.ad-panel--zones.is-fullscreen .ad-zmini-of {
  font-size: 18px;
}

.ad-panel--zones.is-fullscreen .ad-zmini-resp {
  font-size: 20px;
}

.ad-panel--zones.is-fullscreen .ad-zrow-name {
  font-size: 24px !important;
}

.ad-panel--zones.is-fullscreen .ad-zrow-seg {
  font-size: 22px;
}

.ad-panel--zones.is-fullscreen .ad-zrow-resp {
  font-size: 28px;
}

.ad-panel--zones.is-fullscreen .ad-zlegend {
  font-size: 20px;
}

/* زمان‌های کلیدی */
.ad-panel--times.is-fullscreen .ad-times {
  gap: 16px;
}

.ad-panel--times.is-fullscreen .ad-time {
  gap: 10px;
}

.ad-panel--times.is-fullscreen .ad-time-label {
  font-size: 26px;
}

.ad-panel--times.is-fullscreen .ad-time-val {
  font-size: 52px;
}

.ad-panel--times.is-fullscreen .ad-time-goal {
  font-size: 22px;
}

.ad-panel--times.is-fullscreen .ad-time-track {
  height: 16px;
}

.ad-panel--times.is-fullscreen .ad-time-marker {
  top: -6px;
  height: 28px;
  width: 4px;
}

.ad-footer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  border: 1px solid;
  border-radius: 15px;
  padding: 15px 10px;
}

.ad-footer .titleStatus {
  font-size: 24px;
  font-weight: 700;
}
</style>